import { render, staticRenderFns } from "./ShopGoodsList.vue?vue&type=template&id=49859efc&scoped=true"
import script from "./ShopGoodsList.vue?vue&type=script&lang=js"
export * from "./ShopGoodsList.vue?vue&type=script&lang=js"
import style0 from "./ShopGoodsList.vue?vue&type=style&index=0&id=49859efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49859efc",
  null
  
)

export default component.exports